import { Extension } from "@tiptap/core";

import { DOT_PHRASE_FIELD_COMMANDS } from "./dot-phrase-field-navigation";
import { buildDotPhraseFieldsPlugin } from "./dot-phrase-fields-state";

const DOT_PHRASE_FIELDS_PRIORITY = 200;

const DotPhraseFields = Extension.create({
  name: "dotPhraseFields",

  priority: DOT_PHRASE_FIELDS_PRIORITY,

  addKeyboardShortcuts() {
    return {
      Tab: ({ editor }) => DOT_PHRASE_FIELD_COMMANDS.next(editor.state, editor.view.dispatch),
      "Shift-Tab": ({ editor }) =>
        DOT_PHRASE_FIELD_COMMANDS.previous(editor.state, editor.view.dispatch),
      Enter: ({ editor }) => DOT_PHRASE_FIELD_COMMANDS.accept(editor.state, editor.view.dispatch),
    };
  },

  addProseMirrorPlugins() {
    return [buildDotPhraseFieldsPlugin()];
  },
});

export default DotPhraseFields;
